var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDotsLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 367,
    viewBox: "0 0 390 367",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 375.978,
    cy: 268.004,
    r: 13.4966,
    transform: "rotate(-180 375.978 268.004)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 285.358,
    cy: 352.84,
    r: 13.4966,
    transform: "rotate(-180 285.358 352.84)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 285.358,
    cy: 268.004,
    r: 13.4966,
    transform: "rotate(-180 285.358 268.004)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.737,
    cy: 352.84,
    r: 13.4966,
    transform: "rotate(-180 194.737 352.84)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.737,
    cy: 268.004,
    r: 13.4966,
    transform: "rotate(-180 194.737 268.004)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.117,
    cy: 352.84,
    r: 13.4966,
    transform: "rotate(-180 104.117 352.84)",
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.117,
    cy: 268.004,
    r: 13.4966,
    transform: "rotate(-180 104.117 268.004)",
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.978,
    cy: 183.169,
    r: 13.4966,
    transform: "rotate(-180 375.978 183.169)",
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.978,
    cy: 98.332,
    r: 13.4966,
    transform: "rotate(-180 375.978 98.332)",
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 285.358,
    cy: 183.169,
    r: 13.4966,
    transform: "rotate(-180 285.358 183.169)",
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 285.358,
    cy: 98.332,
    r: 13.4966,
    transform: "rotate(-180 285.358 98.332)",
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.737,
    cy: 183.168,
    r: 13.4966,
    transform: "rotate(-180 194.737 183.168)",
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.737,
    cy: 98.332,
    r: 13.4966,
    transform: "rotate(-180 194.737 98.332)",
    fill: "white"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.117,
    cy: 183.168,
    r: 13.4966,
    transform: "rotate(-180 104.117 183.168)",
    fill: "white"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.117,
    cy: 98.332,
    r: 13.4966,
    transform: "rotate(-180 104.117 98.332)",
    fill: "white"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.4963,
    cy: 268.004,
    r: 13.4966,
    transform: "rotate(-180 13.4963 268.004)",
    fill: "white"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.4963,
    cy: 183.168,
    r: 13.4966,
    transform: "rotate(-180 13.4963 183.168)",
    fill: "white"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.4963,
    cy: 98.332,
    r: 13.4966,
    transform: "rotate(-180 13.4963 98.332)",
    fill: "white"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 285.358,
    cy: 13.497,
    r: 13.4966,
    transform: "rotate(-180 285.358 13.497)",
    fill: "white"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.737,
    cy: 13.497,
    r: 13.4966,
    transform: "rotate(-180 194.737 13.497)",
    fill: "white"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.117,
    cy: 13.497,
    r: 13.4966,
    transform: "rotate(-180 104.117 13.497)",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsLight);
export default __webpack_public_path__ + "static/media/dots-light.4b737950640d14e72d7b92dc016add23.svg";
export { ForwardRef as ReactComponent };